export const en: Record<string, string> = {
  'app.title': 'Selektiraj Otpad',
  'app.subtitle': 'Admin panel',

  'nav.group.operations': 'Operations',
  'nav.group.catalog': 'Reference data',
  'nav.group.rewards': 'Rewards',
  'nav.group.system': 'System',
  'nav.dashboard': 'Overview',
  'nav.appointments': 'Bag collections',
  'nav.bags': 'Bag requests',
  'nav.schedules': 'Schedules',
  'nav.municipalities': 'Municipalities',
  'nav.regions': 'Regions',
  'nav.companies': 'Companies',
  'nav.recycleTypes': 'Waste types',
  'nav.users': 'Users',
  'nav.rewards': 'Points & payouts',
  'nav.prizeBudgets': 'Prize budget',
  'nav.smartBins': 'Smart bins',
  'nav.qrCodes': 'QR codes',
  'nav.audit': 'Audit log',

  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.create': 'Add',
  'common.close': 'Close',
  'common.search': 'Search',
  'common.actions': 'Actions',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.confirmDelete': 'Are you sure you want to delete this record?',
  'common.saved': 'Saved.',
  'common.deleted': 'Deleted.',
  'common.error': 'Something went wrong. Please try again.',
  'common.offline': 'The server is not reachable.',
  'common.loading': 'Loading…',
  'common.noData': 'No data.',
  'common.refresh': 'Refresh',
  'common.all': 'All',
  'common.logout': 'Log out',
  'common.language': 'Language',
  'common.theme': 'Dark/light theme',
  'common.details': 'Details',
  'common.from': 'From',
  'common.to': 'To',
  'common.total': 'Total',
  'common.required': 'Required field',
  'common.copy': 'Copy',
  'common.copied': 'Copied.',
  'common.tableView': 'Table',

  'login.title': 'Sign in',
  'login.email': 'E-mail',
  'login.password': 'Password',
  'login.submit': 'Sign in',
  'login.forgot': 'Forgot password?',
  'login.forgotSent': 'If an account with that e-mail exists, we sent a reset link.',
  'login.forgotHint': 'Enter your e-mail above and click again.',

  'reset.title': 'New password',
  'reset.newPassword': 'New password',
  'reset.hint': 'At least 8 characters, including a letter and a digit.',
  'reset.submit': 'Set password',
  'reset.done': 'Your password was changed. Please sign in.',

  'noAccess.title': 'No access',
  'noAccess.text': 'Your account is not allowed to use the admin panel. Please use the mobile app.',

  'field.name': 'Name',
  'field.regionCode': 'Region code',
  'field.languageCode': 'Language',
  'field.dateFormat': 'Date format',
  'field.timeFormat': 'Time format',
  'field.currencyCode': 'Currency',
  'field.currencySymbol': 'Currency symbol',
  'field.region': 'Region',
  'field.isSpecial': 'Special (company) location',
  'field.isGlobal': 'Notify all members',
  'field.showSmartBins': 'Smart bins',
  'field.allowAwards': 'Rewards',
  'field.allowDashboard': 'Dashboard',
  'field.active': 'Active',
  'field.municipalities': 'Municipalities',
  'field.color': 'Color',
  'field.labelHint': 'App label',
  'field.showInApp': 'Show in the app',
  'field.allowedForbidden': 'Allowed/forbidden description',
  'field.titleAllowed': 'Title 1',
  'field.allowed': 'Text 1',
  'field.titleForbidden': 'Title 2',
  'field.forbidden': 'Text 2',
  'field.titleRules': 'Title 3',
  'field.rules': 'Text 3',
  'field.image': 'Image',
  'field.date': 'Date',
  'field.hourFrom': 'From',
  'field.hourTo': 'To',
  'field.municipality': 'Municipality',
  'field.location': 'Location',
  'field.latitude': 'Latitude',
  'field.longitude': 'Longitude',
  'field.email': 'E-mail',
  'field.fullName': 'Full name',
  'field.role': 'Role',
  'field.company': 'Company',
  'field.address': 'Address',
  'field.phone': 'Phone',
  'field.password': 'Password',
  'field.allowQuality': 'May mark waste quality',
  'field.status': 'Status',
  'field.code': 'Code',
  'field.codeKind': 'Code kind',
  'field.recycleType': 'Waste type',
  'field.collectorKg': 'Kg (collector)',
  'field.companyKg': 'Kg (company)',
  'field.points': 'Points',
  'field.quality': 'Quality',
  'field.user': 'User',
  'field.amount': 'Amount (MKD)',
  'field.note': 'Note',
  'field.prizeType': 'Prize',
  'field.dateFrom': 'Valid from',
  'field.dateTo': 'Valid to',
  'field.numberOfPrizes': 'Number of prizes',
  'field.winningsInPeriod': 'Wins per period',
  'field.periodDays': 'Period (days)',
  'field.numberOfWinnings': 'Won so far',
  'field.title': 'Title',
  'field.progress': 'Fill level',
  'field.lastReport': 'Last report',
  'field.createdAt': 'Created',
  'field.balance': 'Current points',
  'field.earned': 'Total earned',
  'field.spent': 'Spent',
  'field.bags': 'Bags',
  'field.rank': 'Rank',
  'field.kg': 'Kg',
  'field.count': 'Count',
  'field.action': 'Action',
  'field.actor': 'User',
  'field.entity': 'Record',
  'field.ip': 'IP address',
  'field.type': 'Type',
  'field.scheduledFor': 'Schedule',
  'field.firstScan': 'First scan',
  'field.confirmedAt': 'Confirmed',

  'role.Admin': 'Administrator',
  'role.SubAdmin': 'Sub-administrator',
  'role.User': 'Citizen',
  'role.Collector': 'Collector',
  'role.SuperUserCollector': 'Lead collector',
  'role.Company': 'Company',
  'role.SunilensSpecialAdmin': 'Special administrator',

  'status.0': 'With user',
  'status.1': 'With collector',
  'status.2': 'Arrived at company',
  'status.3': 'Failed',
  'status.4': 'With collector (status)',
  'quality.clean': 'Clean waste',
  'quality.contaminated': 'Contaminated waste',
  'quality.none': 'Not rated',
  'codeKind.standard': 'Standard',
  'codeKind.special': 'Special (reusable)',
  'bagStatus.0': 'Open',
  'bagStatus.1': 'Delivered',

  'prize.-1': 'Bonus spin',
  'prize.0': 'No prize',
  'prize.5': '5 points',
  'prize.10': '10 points',
  'prize.15': '15 points',
  'prize.20': '20 points',
  'prize.500': '500 MKD',
  'prize.1000': '1000 MKD',
  'prize.2000': '2000 MKD',
  'prize.3000': '3000 MKD',

  'dashboard.title': 'Overview',
  'dashboard.scope': 'Municipality',
  'dashboard.allMunicipalities': 'All municipalities',
  'dashboard.bags': 'Scanned bags',
  'dashboard.openBags': 'Waiting for pickup',
  'dashboard.withCollector': 'With collector',
  'dashboard.confirmed': 'Arrived at company',
  'dashboard.contaminationRate': 'Contaminated',
  'dashboard.totalKg': 'Recycled (kg)',
  'dashboard.citizens': 'Active citizens',
  'dashboard.smartBins': 'Smart bins',
  'dashboard.fullBins': 'over 80% full',
  'dashboard.today': 'Today',
  'dashboard.scannedToday': 'scanned',
  'dashboard.confirmedToday': 'confirmed',
  'dashboard.last7': 'Last 7 days',
  'dashboard.thisMonth': 'This month',
  'dashboard.kgByType': 'Recycled kilograms by waste type',
  'dashboard.bagsByMonth': 'Confirmed bags per month',
  'dashboard.topLocations': 'Most active locations',
  'dashboard.recent': 'Recent activity',

  'appointments.title': 'Bag collections',
  'appointments.editTitle': 'Correct a collection',
  'appointments.pointsHint': 'The points ledger is synchronised with the status automatically.',

  'bags.title': 'Bag requests',
  'bags.close': 'Mark delivered',
  'bags.closed': 'The request was closed.',

  'schedules.title': 'Collection schedules',
  'municipalities.title': 'Municipalities and locations',
  'regions.title': 'Regions',
  'companies.title': 'Recycling companies',
  'companies.links': 'Municipalities served',
  'companies.linksHint': 'The company only sees and confirms bags from these municipalities.',
  'recycleTypes.title': 'Waste types',
  'recycleTypes.translations': 'Translations',
  'recycleTypes.translationsTitle': 'Translations per region',
  'recycleTypes.missing': 'No translation – the type will not be shown in the app for this region.',
  'recycleTypes.upload': 'Upload image',

  'users.title': 'Users',
  'users.new': 'New user',
  'users.edit': 'Edit user',
  'users.changeRole': 'Change role',
  'users.setPassword': 'Set password',
  'users.activate': 'Activate',
  'users.deactivate': 'Deactivate',
  'users.inactive': 'Inactive',
  'users.points': 'Points',
  'users.ledger': 'Points history',
  'ptx.bag_confirmed': 'Bag confirmed',
  'ptx.prize_spin': 'Wheel spin',
  'ptx.payment': 'Payment',
  'users.passwordSet': 'Password set. All sessions of the user were signed out.',
  'users.roleChanged': 'Role changed.',

  'rewards.title': 'Points & payouts',
  'rewards.rankList': 'Ranking',
  'rewards.spins': 'Wheel spins',
  'rewards.payments': 'Payouts',
  'rewards.newPayment': 'New payout',
  'rewards.reverse': 'Reverse',
  'rewards.confirmReverse': 'Cancel this payment? The record is deleted and the points return to the user (a copy stays in the audit log).',
  'rewards.wonOnly': 'Wins only',
  'rewards.pickUser': 'Pick a user from the ranking',
  'prizeBudgets.title': 'Prize budget',

  'smartBins.title': 'Smart bins',
  'smartBins.keyTitle': 'Device key',
  'smartBins.keyText': 'Enter this key in the device (X-Device-Key header or the SecretKey field). It is derived from SMARTBIN_KEY_SECRET: changing that secret gives every device a new key.',
  'smartBins.reports': 'Reports',
  'smartBins.ok': 'Success',
  'smartBins.failed': 'Failed',

  'qr.title': 'Bag QR codes',
  'qr.count': 'Number of codes',
  'qr.kind': 'Kind',
  'qr.generate': 'Generate',
  'qr.print': 'Print',
  'qr.hint': 'Codes are signed and cannot be invented. Standard codes are single-use; special codes are for fixed locations.',

  'audit.title': 'Audit log',
  'audit.filter': 'Filter by action',
  'users.active': 'Active',
  'users.lockedUntil': 'Locked until {date}',
  'smartBins.showKey': 'Device key',
  'smartBins.noKeySecret': 'SMARTBIN_KEY_SECRET is not set on the server: devices can only report with the old shared secret.',
  'municipalities.specialHint': 'Special (company) locations have negative ids in the database and are not created from the panel.',
};
